(() => {
  if (customElements.get('faq-tabs')) {
    return;
  }

  class FaqTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.querySelectorAll('button[type="button"]').forEach((button) => {
        button.addEventListener('click', this.toggle.bind(this));
      });
    }

    toggle(event) {
      const button = event.target;

      this.querySelector('button.is-active').classList.remove('is-active');
      button.classList.add('is-active');

      this.querySelectorAll('[data-list-faq]').forEach((el) => {
        el.classList.add('hidden');
      });

      this.querySelectorAll(`[data-list-id="${button.dataset.id}"]`).forEach(
        (el) => {
          el.classList.remove('hidden');
        },
      );
    }
  }

  customElements.define('faq-tabs', FaqTabs);
})();
